import React, { useState, useEffect } from "react";
import { getRoles } from "@api/rolesController";
import { PageHeader, PageTitle, Button, Input, SimpleTable } from "@components";
import {
  SectionHeader,
  SectionTitle,
  SectionTagline,
  ControlStrip,
} from "../components";
import AddRole from "../flows/AddRole";
import EditRole from "../flows/EditRole";
import { PlusLg } from "react-bootstrap-icons";
import { useUser, useMerchant } from "@auth";

function Team() {
  const { user } = useUser();
  const { merchant } = useMerchant();
  const [roles, setRoles] = useState([]);
  const [addRoleIsOpen, setAddRoleIsOpen] = useState(false);
  const [editRoleDetails, setEditRoleDetails] = useState(null);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    const data = await getRoles();
    const sortedData = data.sort((a, b) => a.name.localeCompare(b.name));
    setRoles(sortedData);
  };

  const tableConfig = () => {
    return {
      rowActions: [
        {
          label: "Edit",
          onClick: (x) => setEditRoleDetails(x),
        },
      ],
      columns: [
        {
          title: "Name",
          width: "144px",
          render: (x) => x.name,
        },
      ],
    };
  };

  const onModalClose = () => {
    setAddRoleIsOpen(false);
    setEditRoleDetails(null);
  };

  const openAddRole = () => setAddRoleIsOpen(true);

  return (
    <>
      <div className="flex flex-col items-center py-4 px-5 border-b border-zinc-200 grow overflow-hidden">
        <div className="py-8 w-full max-w-4xl grow flex flex-col overflow-hidden">
          <SectionHeader>
            <SectionTitle>Roles</SectionTitle>
            <SectionTagline>
              Manage workspace members, set access levels, and invite new team
              members
            </SectionTagline>
            {user.memberships.length > 1 && (
              <SectionTagline>
                These changes apply to your account with <b>{merchant.name}</b>
              </SectionTagline>
            )}
          </SectionHeader>
          <ControlStrip>
            <Button onClick={openAddRole} color="primary">
              <PlusLg className="mr-2" />
              Add role
            </Button>
          </ControlStrip>
          <SimpleTable config={tableConfig()} data={roles} extraCol />
        </div>
      </div>
      <AddRole
        isOpen={addRoleIsOpen}
        onClose={onModalClose}
        onComplete={fetchRoles}
      />
      {!!editRoleDetails && (
        <EditRole
          editRoleDetails={editRoleDetails}
          onClose={onModalClose}
          onComplete={fetchRoles}
        />
      )}
    </>
  );
}

export default Team;
